import { em } from "polished";
import styled, { css } from "styled-components";

interface IProps {
  size?: string;
}

export const ScrollTable = styled.div`
  @media (max-width: ${em("480px")}) {
    /* @media (max-width: ${({ theme }) => theme.breakpoints[4]}) { */
    overflow-x: auto;

    table {
      width: 48rem;
    }
  }
`;

const Table = styled.table<IProps>`
  width: 100%;
  border-collapse: collapse;
  border-width: 0 1px;
  border-style: solid;
  font-size: ${({ theme }) => theme.fontSizes[3]};
  border-color: transparent;

  th,
  td {
    font-family: ${({ theme }) => theme.fonts.book};
    font-weight: 400;

    ${({ size }) =>
      size === "lg" &&
      css`
        padding: ${({ theme }) => `${theme.space[3]} ${theme.space[2]}`};
      `}
  }
  td {
    padding: ${({ theme }) => `${theme.space[2]}`};
    font-size: ${({ theme }) => theme.fontSizes[3]};
  }

  th {
    padding: ${({ theme }) => `${theme.space[1]} ${theme.space[2]}`};
    background-color: ${({ theme }) => theme.colors.grey24};
    font-size: ${({ theme }) => theme.fontSizes[2]};
    color: ${({ theme }) => theme.colors.white1};
    text-align: start;
    text-wrap: wrap;

    @media (max-width: ${({ theme }) => theme.breakpoints[4]}) {
      word-wrap: none;
    }
  }

  th:first-of-type {
    border-start-start-radius: ${({ theme }) => theme.radii[1]};
    border-end-start-radius: ${({ theme }) => theme.radii[1]};
  }

  th:last-of-type {
    border-start-end-radius: ${({ theme }) => theme.radii[1]};
    border-end-end-radius: ${({ theme }) => theme.radii[1]};
  }

  tr {
    background-color: transparent;
  }
`;

export default Table;
